/**
 * jw-product-cart.js
 * Phase F2.6.1 — Cart Payload Adapter (execution layer, zero business logic)
 *
 * 职责：
 *   buildPayload(variantId, qty) → {id, quantity}
 *   add(items) → POST /cart/add.js
 *
 * Cart is an execution layer. It does not decide, derive, or calculate anything.
 * The only allowed transformation: type coercion (id→Number, qty→Number).
 *
 * 依赖：
 *   None — pure payload builder + fetch wrapper
 *   No dependency on JWProductPricing / JWProductContext / JWProductState
 *
 * 🚫 禁止：
 *   - 计算价格 / 折扣 / tier
 *   - 查找 variant / SKU (variantId must come from caller)
 *   - 读取 priceRaw / tierData / imageBinding
 *   - 操作 DOM
 *   - 读取 S.activeSku / S.qtys (belongs to State)
 *
 * Contract: docs/contracts/product_cart_v1.md
 */
(function () {
  'use strict';

  /**
   * Build a Shopify Cart API payload item.
   * The ONLY allowed logic: id → Number, quantity → Math.max(1, ...).
   *
   * @param {number|string} variantId  — Shopify variant ID (from Variant Resolver)
   * @param {number}         quantity   — positive integer
   * @returns {{id:number, quantity:number}}
   */
  function buildPayload(variantId, quantity) {
    return {
      id:       Number(variantId),
      quantity: Math.floor(Math.max(1, Number(quantity) || 1))
    };
  }

  /**
   * Submit items to Shopify Cart AJAX API.
   * Cart owns the API call — nothing else.
   *
   * @param {Array<{id:number, quantity:number}>} items
   * @returns {Promise<object>} Shopify cart response JSON
   */
  function add(items) {
    if (!items || items.length === 0) {
      return Promise.reject(new Error('Cart: no items to add'));
    }
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart: add failed (' + r.status + ')');
      return r.json();
    });
  }

  // ── Expose ──
  window.JWProductCart = {
    buildPayload: buildPayload,
    add:          add
  };

})();
